export default __webpack_public_path__ + "static/media/building-solid.260677a5.svg";